import { authGet } from "@api/auth/auth";
import { UserPermissionsResponse } from "@types";

export const fetchUserPermissions = (
  deploymentId: string
): Promise<UserPermissionsResponse> => {
  return authGet<UserPermissionsResponse>(
    `/api/users/deployments/${deploymentId}/authorized_actions`
  );
};
